import React from "react";

export function Privacy() {
  return (
    <svg
      width="12"
      height="11"
      viewBox="0 0 12 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.56076 0L5.12598 4.13389L5.56076 11C8.31815 9.51077 10.0334 7.64614 10.0334 4.04856V0H5.56076Z"
        fill="#FFAB00"
      />
      <path
        d="M1.08807 0V4.04856C1.08807 7.64614 2.80338 9.51077 5.56076 11V0H1.08807Z"
        fill="#FFC813"
      />
      <path
        d="M5.56076 1.03131L5.12598 4.13389L5.56076 9.81281C6.6649 9.16025 7.43924 8.48952 7.97459 7.72679C8.65837 6.75262 8.99076 5.54947 8.99076 4.04858V1.03131H5.56076Z"
        fill="#FFC813"
      />
      <path
        d="M2.1308 1.03131V4.04858C2.1308 5.54947 2.46318 6.75262 3.14696 7.72679C3.68232 8.48952 4.45666 9.16025 5.5608 9.81281V1.03131H2.1308Z"
        fill="#FFDF78"
      />
      <path
        d="M5.56076 2.68512L5.12598 4.13388L5.56076 6.93853H6.26993V5.01536C6.61676 4.7878 6.84554 4.39833 6.84554 3.95583C6.84554 3.25405 6.27032 2.68512 5.56076 2.68512Z"
        fill="#242424"
      />
      <path
        d="M4.276 3.95586C4.276 4.39835 4.5048 4.78782 4.85161 5.01538V6.93855H5.56078V2.68512C4.85121 2.68512 4.276 3.25405 4.276 3.95586Z"
        fill="#242424"
      />
    </svg>
  );
}
